/**
 * AES 加密工具类
 * 特别注意：AES加密中需要前后端共同协商一个密文(密钥),用来加密/解密的。
 * 默认密钥：abcdefG1234567
 */
import CryptoJS from 'crypto-js';

const DEFAULT_KEY = process.env.VUE_APP_ECB_KEY
const DEFAULT_IV =process.env.VUE_APP_ECB_IV
// 默认密钥和初始向量
// const DEFAULT_KEY = 'f2cd84445a1f30558d94a49be1794af0';
// const DEFAULT_IV = 'abcdefG1234567';

/**
 * AES 加密工具
 */
const crypto = {
    /**
     * ECB 模式加密
     * @param {string} word - 要加密的文本
     * @param {string} keyStr - 密钥（16位），可选
     * @returns {string} 加密后的字符串
     */
    encryptECB(word, keyStr = DEFAULT_KEY) {
        const key = CryptoJS.enc.Utf8.parse(keyStr);
        const srcs = CryptoJS.enc.Utf8.parse(word);
        const encrypted = CryptoJS.AES.encrypt(srcs, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    },

    /**
     * ECB 模式解密
     * @param {string} word - 要解密的文本
     * @param {string} keyStr - 密钥（16位），可选
     * @returns {string} 解密后的字符串
     */
    decryptECB(word, keyStr = DEFAULT_KEY) {
        const key = CryptoJS.enc.Utf8.parse(keyStr);
        const decrypt = CryptoJS.AES.decrypt(word, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    },

    /**
     * CBC 模式加密
     * @param {string} word - 要加密的文本
     * @param {string} keyStr - 密钥（16位），可选
     * @param {string} ivStr - 初始向量（16位），可选
     * @returns {string} 加密后的字符串
     */
    encryptCBC(word, keyStr = DEFAULT_KEY, ivStr = DEFAULT_IV) {
        const key = CryptoJS.enc.Utf8.parse(keyStr);
        const iv = CryptoJS.enc.Utf8.parse(ivStr);
        const srcs = CryptoJS.enc.Utf8.parse(word);

        const encrypted = CryptoJS.AES.encrypt(srcs, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        });

        return encrypted.toString();
    },

    /**
     * CBC 模式解密
     * @param {string} word - 要解密的文本
     * @param {string} keyStr - 密钥（16位），可选
     * @param {string} ivStr - 初始向量（16位），可选
     * @returns {string} 解密后的字符串
     */
    decryptCBC(word, keyStr = DEFAULT_KEY, ivStr = DEFAULT_IV) {
        const key = CryptoJS.enc.Utf8.parse(keyStr);
        const iv = CryptoJS.enc.Utf8.parse(ivStr);

        const decrypt = CryptoJS.AES.decrypt(word, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        });

        return decrypt.toString(CryptoJS.enc.Utf8);
    },

    // 兼容旧版本的方法名（默认使用 ECB 模式）
    encrypt: function (word, keyStr) {
        return this.encryptECB(word, keyStr);
    },

    decrypt: function (word, keyStr) {
        return this.decryptECB(word, keyStr);
    }
};

export default crypto;